<article class="dialog-content">
  <mat-calendar class="bms-theme" [headerComponent]="datepickerHeader" [minDate]="minDate" (selectedChange)="onSelectedChanges($event)" [selected]="selected" [startAt]="startAtDate"></mat-calendar>
</article>
